<template>
  <div v-if="opqIf">
    <infobulle :descriptionPopup="descriptionPopup">
      <div v-html="libelleLong" class="mb-1"></div>
      <div class="d-sm-flex">
        <v-autocomplete
          v-if="!hideHours"
          v-bind="$attrs"
          v-model="hour"
          :items="hours"
          label="Heures"
          style="width: 100px"
          class="flex-grow-0 mr-2 mb-2 mb-sm-0"
          @input="handleChange"
          @blur="handleBlur"
          :rules="hourRules"
          outlined
          dense
          :loading="updating"
          :disabled="updating || disabled"
          auto-select-first
          :error="!conditionRespectee"
        ></v-autocomplete>

        <v-autocomplete
          v-if="!hideMinutes"
          v-bind="$attrs"
          v-model="minute"
          :items="minutes"
          label="Minutes"
          style="width: 140px"
          class="flex-grow-0 mr-2 mb-2 mb-sm-0"
          @input="handleChange"
          @blur="handleBlur"
          :rules="minuteRules"
          outlined
          dense
          :loading="updating"
          :disabled="updating || disabled"
          auto-select-first
          :error="!conditionRespectee"
        ></v-autocomplete>
        <v-btn v-if="valid && !disabled" icon text class="ml-1" @click="clear"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <div v-if="!conditionRespectee" class="error--text mt-n2">{{ conditionMessage }}</div>
      <v-checkbox class="list_counter_validator my-2 ml-6 p-0" :input-value="conditionRespectee" :rules="[(v) => optional || !!v]"></v-checkbox>
    </infobulle>
  </div>
</template>

<script>
import ChampBase from "@/mixins/ChampBase"
import { Api, Queue } from "@/plugins/api"

// @group Champs
export default {
  mixins: [ChampBase],

  props: {
    minutesInterval: {type: Number, default: 1},
    hideHours : Boolean,
    hideMinutes : Boolean,
    maxHour : { type : Number },
    code: { type: String, required: true },
    live: { type: Object },
    optional: Boolean,
    value:  { type: String },
    opqIf: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    condition: { type: Function, required: false },
    conditionMessage: { type: String }
  },

  data() {
    return {
      hour: null,
      minute: null,
      res: null,
      hours: [],
      minutes: [],
      updating: false
    }
  },

  created() {
    this.setHours()
    this.setMinutes()
    this.setValues(this.value)
    this.handleBlur()
    this.handleChange()
  },

  computed: {
    hourRules() {
      return [(v) => this.optional || this.hours.indexOf(v) > -1 || "Heures"]
    },
    minuteRules() {
      return [(v) => this.optional || this.minutes.indexOf(v) > -1 || "Minutes"]
    },

    conditionRespectee() {
      if (typeof this.condition == "function") {
        return this.condition(this.stringValue)
      }
      return true
    },

    stringValue() {
      if (this.hour == null && this.minute == null) {
        return null
      }
      else if (this.hour != null && this.minute == null) {
        return `${this.hour}:00`
      }
      else if (this.hour == null && this.minute != null) {
        return `0:${this.minute}`
      }
      return `${this.hour}:${this.minute}`
    },
  },

  methods: {
    valid() {
      return (this.hour || this.hideHours) && (this.minute || this.hideMinutes)
    },

    setHours(){
      this.hours = []
      for (let a = 0; a <= this.maxHour; a++) {
        this.hours.push(a.toString())
      }
    },

    setMinutes(){
      this.minutes = []
      for (let a = 0; a < 60; a += this.minutesInterval) {
        this.minutes.push(
          a < 10 ? "0" + a.toString() : a.toString()
        )
      }
    },

    handleChange() {
      if (this.valid) {
        this.$emit("input", this.stringValue)
      }
    },

    handleBlur(priority = 1) {
      if (this.valid) {
        this.updating = true
        if (this.live) {
          Queue.enqueue(
            () =>
              Api.post(this.live.endpoint, {
                fileId: this.live.fileId,
                cle: this.live.cle,
                value: this.stringValue
              }).finally(() => {
                this.updating = false
              }),
            priority
          )
        }
      }
    },

    setValues(value) {
      if (value) {
        let match = value.match(/^([0-9]{1,}):([0-5][0-9])$/)
        if (match) {
          this.hour = match[1]
          this.minute = match[2]
        }
      }
    },

    clear() {
      this.hour = null
      this.minute = null
      if (this.live) {
        Queue.enqueue(() =>
          Api.post(this.live.endpoint, {
            fileId: this.live.fileId,
            cle: this.live.cle,
            value: null
          }).finally(() => {
            this.updating = false
          })
        )
      }
      this.$emit("input", null)
    }
  },

  watch: {
    opqIf(newValue) {
      if (!newValue) {
        this.clear()
      }
    }
  }
}
</script>

<style>
</style>